import { ShowsSlider } from '@/components/ShowsSlider';
import { LabradorComponent } from '@/types/component';

export const LabradorShowsSlider: LabradorComponent = ({ descendants }) => {
  const showsItems = descendants.map((descendant) => descendant.data);

  return <ShowsSlider shows={showsItems} />;
};
